import Result from './result'

// @namespace Model
export default class DiscourseResult extends Result {
  feature () {
    return this.poll().toggle('featured_result_id', {}, this.id)
  }

  unfeature () {
    return this.poll().toggle('featured_result_id', {}, null)
  }

  unapprove () {
    return this.save({ approved: false })
  }

  isUnapproved () {
    return this.get('approved') === false
  }
}
